/** Durée du fondu (ms) — alignée sur le CSS. */
export const TOOLTIP_FADE_MS = 140;
/** Durée du slide+fondu panneau points (ms). */
export const TOOLTIP_SLIDE_MS = 160;

const leaveTimers = new WeakMap<HTMLElement, ReturnType<typeof setTimeout>>();

function clearLeaveTimer(el: HTMLElement): void {
  const t = leaveTimers.get(el);
  if (t != null) {
    clearTimeout(t);
    leaveTimers.delete(el);
  }
}

/** Annule une sortie en cours (démontage / reset tests). */
export function cancelTooltipLeave(el: HTMLElement | null | undefined): void {
  if (!el) return;
  clearLeaveTimer(el);
  el.classList.remove('is-tooltip-leaving', 'is-slide-leaving');
}

/** Affiche le tooltip avec fondu (retire `hidden`, ajoute `is-tooltip-visible`). */
export function openTooltipFade(el: HTMLElement): void {
  clearLeaveTimer(el);
  el.classList.remove('is-tooltip-leaving');
  el.hidden = false;
  // Force un frame à opacity 0 avant d’ouvrir (sinon pas de transition).
  void el.getBoundingClientRect();
  requestAnimationFrame(() => {
    if (el.hidden) return;
    el.classList.add('is-tooltip-visible');
  });
}

/** Masque le tooltip avec fondu puis pose `hidden`. */
export function closeTooltipFade(el: HTMLElement, afterHidden?: () => void): void {
  clearLeaveTimer(el);
  el.classList.remove('is-tooltip-visible');
  el.classList.add('is-tooltip-leaving');
  leaveTimers.set(
    el,
    setTimeout(() => {
      leaveTimers.delete(el);
      el.classList.remove('is-tooltip-leaving');
      el.hidden = true;
      afterHidden?.();
    }, TOOLTIP_FADE_MS)
  );
}

/** Affiche un panneau avec slide depuis la gauche + fondu. */
export function openTooltipSlideLeft(el: HTMLElement): void {
  clearLeaveTimer(el);
  el.classList.remove('is-slide-leaving');
  el.hidden = false;
  void el.getBoundingClientRect();
  requestAnimationFrame(() => {
    if (el.hidden) return;
    el.classList.add('is-slide-open');
  });
}

/** Masque un panneau avec slide vers la gauche + fondu. */
export function closeTooltipSlideLeft(el: HTMLElement, afterHidden?: () => void): void {
  clearLeaveTimer(el);
  el.classList.remove('is-slide-open');
  el.classList.add('is-slide-leaving');
  leaveTimers.set(
    el,
    setTimeout(() => {
      leaveTimers.delete(el);
      el.classList.remove('is-slide-leaving');
      el.hidden = true;
      afterHidden?.();
    }, TOOLTIP_SLIDE_MS)
  );
}

/** True si le panneau n’est ni masqué ni en cours de sortie. */
export function isTooltipSlideOpen(el: HTMLElement | null): boolean {
  return el != null && !el.hidden && !el.classList.contains('is-slide-leaving');
}
